<template>
  <div class="el-section">
    <div class="emd-container">
      <div class="emd-container__header eu-py_4_md eu-px_5_md">
        <h2 class="emd-text _size_section _color_default">{{ $t("title") }}</h2>
      </div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md">
        <emd-alert
          v-if="tabbarError.status"
          variant="danger"
          :title="$t('tabbarError.parcial')"
          @cancel="tabbarError.status = false"
          autoclose
        />
        <div class="eu-display_none eu-display_block_md eu-mb_3">
          <div class="eu-flex">
            <div class="eu-flex-item eu-basis_5">
              <label class="emd-label _required">{{ $t("description") }}</label>
            </div>
            <div class="eu-flex-item eu-basis_2">
              <label class="emd-label _required">{{ $t("value") }}</label>
            </div>
            <div class="eu-flex-item eu-basis_2">
              <label class="emd-label _required">{{ $t("quantity") }}</label>
            </div>
            <div class="eu-flex-item eu-basis_3 emd-text _align_right">
              <label class="emd-label">{{ $t("subtotal") }}</label>
            </div>
          </div>
        </div>
        <div class="eu-flex" v-for="(item, index) in items" :key="index">
          <div class="eu-flex-item eu-basis_12 eu-basis_5_md">
            <div class="emd-form-group">
              <label class="emd-label eu-display_none_md">{{
                $t("description")
              }}</label>
              <input
                class="emd-input"
                :class="{
                  _state_error:
                    $v.items.$each[index].description.$invalid &&
                    showFeedbacks.status,
                }"
                v-model="item.description"
                :id="`description_${index}`"
              />
              <p
                class="emd-input-feedback _state_error"
                v-if="
                  $v.items.$each[index].description.$invalid &&
                  showFeedbacks.status
                "
              >
                {{ $t("hint.required") }}
              </p>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_12 eu-basis_2_md">
            <div class="emd-form-group">
              <label class="emd-label eu-display_none_md">{{
                $t("value")
              }}</label>
              <money
                class="emd-input"
                type="tel"
                :id="`amount_${index}`"
                name="item[]"
                v-bind="money"
                v-model="item.amount"
                @input="filterChar(item)"
                :class="{
                  _state_error:
                    $v.items.$each[index].amount.$invalid &&
                    showFeedbacks.status,
                }"
              ></money>
              <p
                class="emd-input-feedback _state_error"
                v-if="
                  $v.items.$each[index].amount.$invalid && showFeedbacks.status
                "
              >
                {{ $t("hint.value") }}
              </p>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_6 eu-basis_2_md">
            <div class="emd-form-group">
              <label class="emd-label eu-display_none_md">{{
                $t("quantityAbv")
              }}</label>
              <div class="eu-flex eu-align-items_center">
                <div class="eu-flex-item">
                  <div class="emd-input-group _icon_left _icon_right">
                    <a
                      class="emd-input-icon__link"
                      @click="subtractQuantity(item)"
                    >
                      <i class="uil uil-minus"></i>
                    </a>
                    <input
                      class="emd-input eu-align_center"
                      type="text"
                      v-model="item.quantity"
                      @input="filterCharQuantity(item)"
                      :id="`quantity_${index}`"
                      :class="{
                        _state_error:
                          $v.items.$each[index].quantity.$invalid &&
                          showFeedbacks.status,
                      }"
                    />
                    <a class="emd-input-icon__link" @click="addQuantity(item)">
                      <i class="uil uil-plus"></i>
                    </a>
                  </div>
                  <p
                    class="emd-input-feedback _state_error"
                    v-if="
                      $v.items.$each[index].quantity.$invalid &&
                      showFeedbacks.status
                    "
                  >
                    {{ $t("hint.required") }}
                  </p>
                </div>
                <div class="eu-flex-item eu-shrink_1">
                  <a
                    class="emd-action-button _color_danger _has-tooltip _size_small"
                    data-tooltip="Excluir"
                    :id="`remove_${index}`"
                    v-if="items.length > 1"
                    @click="removeItem(index)"
                  >
                    <i
                      class="emd-text _color_danger emd-action-button__icon uil uil-trash-alt"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="eu-flex-item eu-basis_6 eu-basis_3_md">
            <div class="emd-form-group eu-align_right">
              <label class="emd-label eu-display_none_md">{{
                $t("subtotal")
              }}</label>
              <p class="emd-text _type_caption eu-pt_3">
                {{ setSubtotal(item) }}
              </p>
            </div>
          </div>
        </div>
        <hr class="emd-divider eu-mb_4 _weight_light eu-display_none_md" />
        <div class="el-chunk">
          <button
            class="emd-btn _type_link _color_tertiary eu-ws_nowrap"
            @click="addItem"
            v-if="items.length < 10"
          >
            <i class="uil uil-layer-group"></i>
            {{ $t("addItem") }}
          </button>
        </div>
        <div class="eu-flex eu-justify_end eu-mt_5 eu-mt_6_md">
          <div class="eu-flex-item eu-basis_12 eu-basis_4_sm eu-basis_3_md">
            <div class="emd-form-group">
              <div class="emd-input-group _wrapped">
                <label class="emd-label" for="shipping"
                  >{{ $t("shipping") }}:</label
                >
                <money
                  class="emd-input eu-align_right"
                  type="tel"
                  id="shipping"
                  name="shipping"
                  @input="setTotal && filterChar(shipping)"
                  v-bind="money"
                  v-model="shipping.amount"
                ></money>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="emd-divider" />
      <div
        class="emd-container__footer eu-py_4_md eu-px_5_md eu-justify_space-between eu-align-items_center eu-wrap"
      >
        <div class="eu-flex-item eu-basis_12 eu-basis_6_md">
          <i class="uil uil-info-circle"></i> {{ $t("orderInstruction") }}
        </div>
        <div
          class="eu-flex-item eu-basis_12 eu-basis_6_md eu-align_right eu-mt_5 eu-no-margin_md"
        >
          <span class="emd-label eu-display_inline-block"
            >{{ $t("total") }}:</span
          >
          <p class="emd-text _type_caption eu-display_inline-block eu-ml_1">
            {{ total.amount }}
          </p>
        </div>
      </div>
      <hr class="emd-divider" />
      <div class="emd-container__content eu-pa_5_md">
        <order-code />
      </div>
    </div>
    <div class="el-section">
      <div
        class="eu-display_flex eu-justify_space-between eu-wrap_reverse">
        <button
          class="emd-btn _color_secondary _type_text _block_mobile"
          @click="reverseRoute"
        >
          <i class="uil uil-angle-left"></i>
          {{ $t("back") }}
        </button>
        <button
          class="emd-btn _color_secondary _block_mobile"
          @click="nextRoute"
        >
          {{ $t("paymentMethod") }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import OrderCode from '@/components/project/Items/OrderCode'
import { required, minLength } from 'vuelidate/lib/validators'
import { Money } from 'v-money'
import { formatCurrency, formatToInt, filterChar } from '@/utils/validations'

export default {
  name: 'Items',
  components: {
    Money,
    EmdAlert,
    OrderCode
  },
  computed: {
    items () {
      return this.$store.getters.items
    },
    shipping () {
      return this.$store.getters.shipping
    },
    routesWizard () {
      return this.$store.getters.routesWizard
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    formIsValid () {
      return this.$v.$invalid
    },
    total () {
      return this.$store.getters.total
    },
    tabbarError () {
      return this.$store.getters.tabbarError
    },
    showFeedbacks () {
      return this.$store.getters.showFeedbacks
    },
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    },
    componentName () {
      if (this.hasSubscriptionEnabled) return this.$route.name
      return 'Items'
    },
    isTypedSale () {
      return this.selectedPaymentType === 'typed-sale'
    }
  },
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      }
    }
  },
  validations: {
    items: {
      minLength: minLength(1),
      $each: {
        description: { required },
        amount: {
          required,
          isNotZero (value) {
            if (value !== 'R$ 0,00') return true
            return false
          }
        },
        quantity: { required }
      }
    }
  },
  methods: {
    addItem (item) {
      if (this.items.length === 10) return
      this.items.push({
        amount: '',
        quantity: 1,
        description: null
      })
    },
    addQuantity (item) {
      if (item.quantity === null || item.quantity === '') item.quantity = 1
      else item.quantity = parseInt(item.quantity) + 1
    },
    subtractQuantity (item) {
      if (item.quantity === null) item.quantity = 1
      if (item.quantity > 1) item.quantity = parseInt(item.quantity) - 1
    },
    setSubtotal (item) {
      let subtotal = 'R$ 0,00'
      if (item.quantity && item.amount) {
        const quantity = item.quantity
        const amount = formatToInt(item.amount)
        subtotal = formatCurrency((amount * quantity) / 100)
      }
      this.setTotal()
      return subtotal
    },
    filterChar (item) {
      item.amount = filterChar(item.amount)
    },
    filterCharQuantity (item) {
      if (item.quantity === '0') item.quantity = ''
      item.quantity = item.quantity.replace(/[^\d]+/g, '')
    },
    setTotal () {
      let total = 0
      const shipping = formatToInt(this.shipping.amount)
      this.items.map((item) => {
        if (item.quantity && item.amount) {
          const quantity = item.quantity
          const amount = formatToInt(item.amount)
          total = total + amount * quantity
        }
      })
      this.total.amount = formatCurrency((total + shipping) / 100)
    },
    removeItem (index) {
      this.items.splice(index, 1)
    },
    reverseRoute () {
      this.$router.push({ name: 'OrderType' })
    },
    nextRoute () {
      if (this.formIsValid) this.showFeedbacks.status = true
      else {
        this.$router.push({ name: 'PaymentMethod' })
      }
    }
  },
  watch: {
    formIsValid: {
      handler: function () {
        this.$store.dispatch('SET_PERMISSION', {
          status: this.formIsValid,
          component: this.componentName,
          paymentType: this.selectedPaymentType
        })
        this.tabbarError.status = false
        this.showFeedbacks.status = false
      }
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "description": "Descrição",
      "title": "Itens do pedido",
      "orderInstruction": "Você pode adicionar até 10 produtos diferentes em um pedido.",
      "value": "Valor",
      "quantity": "Quantidade",
      "quantityAbv": "Qtd.",
      "subtotal": "Subtotal",
      "total": "Total",
      "addItem": "Adicionar item",
      "shipping": "Frete",
      "paymentMethod": "Tipo de cobrança",
      "back": "Voltar ao início",
      "customer": "Dados do Cliente",
      "hint": {
        "required": "Este campo é obrigatório",
        "value": "Deve ser maior que 0"
      },
      "tabbarError": {
        "all": "Para prosseguir é necessário adicionar pelo menos um item ao pedido.",
        "parcial": "Alguns campos não foram preenchidos corretamente, por favor verifique."
      }
    },
    "en-US": {
      "description": "Description",
      "title": "Order Items",
      "orderInstruction": "You can add up to 10 different products in one order.",
      "value": "Value",
      "quantity": "Quantity",
      "quantityAbv": "Qty.",
      "subtotal": "Subtotal",
      "total": "Total",
      "addItem": "Add Item",
      "shipping": "Shipping",
      "paymentMethod": "Payment Method",
      "back": "Go back",
      "customer": "Customer",
      "hint": {
        "required": "This field is required",
        "value": "Value must be greater than 0"
      },
      "tabbarError": {
        "all": "To move forward add at least one item to the order.",
        "parcial": "Some fields were filled incorrectly, please verify."
      }
    }
  }
</i18n>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.emd-input-icon__link {
  top: -1px;
}
</style>
